import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ChaseIqUpgradeTooltip from "../../../../shared/chaseIqUpgradeTooltip/ChaseIqUpgradeTooltip";
import { useChaseIqAccess } from "../../../../hooks/useChaseIqAccess";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { AILogoIcon } from "../../../../assets/images/svg";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";

const PredictionToggle = () => {
  const dispatch = useDispatch();
  const showPrediction = useSelector((state) => state.numberOfActiveMembersBy.showPrediction);
  const hasAIAccess = useChaseIqAccess();

  const handleToggle = (val) => {
    if (!hasAIAccess) return;
    dispatch(actionCreators.togglePrediction(val));
  };

  return (
    <div className="select-box-no-width prediction-toggle">
      <p>
        Prediction by <AILogoIcon className="chaseiq-logo-inline" /> ChaseIQ
      </p>
      <div>
        <ToggleableButton
          isRadio
          isActive={showPrediction}
          title="chaseiq-prediction"
          onClick={handleToggle}
        />
        {!hasAIAccess && (
          <ChaseIqUpgradeTooltip anchorSelect="label[for='section-toggle-chaseiq-prediction']" />
        )}
      </div>
    </div>
  );
};

export default PredictionToggle;
